import { Check, CreditCard, Lock, QrCode } from "lucide-react";
import { brl } from "../../lib/data";
import { calcPricing, daysUntil, fmtDate } from "../../lib/pricing";

const Option = ({ id, on, disabled, onClick, title, badge, children }) => (
  <button type="button" disabled={disabled} onClick={onClick} data-testid={id}
    className={`relative text-left rounded-2xl border p-6 transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${on ? "border-[#FFD200] bg-[#FFD200]/10" : "border-white/10 hover:border-white/30"}`}>
    <div className="flex items-center justify-between gap-3">
      <span className="font-display font-bold text-lg text-white">{title}</span>
      <span className={`w-6 h-6 rounded-full border-2 grid place-items-center ${on ? "border-[#FFD200] bg-[#FFD200]" : "border-white/30"}`}>
        {on && <Check className="w-4 h-4 text-[#08080C]" />}
      </span>
    </div>
    {badge && <span className="inline-block mt-2 rounded-full bg-[#E8202A] text-white font-mono text-[11px] uppercase tracking-[0.15em] px-2.5 py-1">{badge}</span>}
    <div className="mt-4 text-sm text-zinc-300 space-y-1">{children}</div>
  </button>
);

const Method = ({ id, on, onClick, icon: Icon, title, text }) => (
  <button type="button" onClick={onClick} data-testid={id}
    className={`text-left rounded-2xl border p-5 flex items-start gap-4 transition-colors ${on ? "border-[#FFD200] bg-[#FFD200]/10" : "border-white/10 hover:border-white/30"}`}>
    <Icon className={`w-6 h-6 shrink-0 ${on ? "text-[#FFD200]" : "text-zinc-400"}`} />
    <span>
      <span className="block font-display font-bold text-white">{title}</span>
      <span className="block text-sm text-zinc-300 mt-1">{text}</span>
    </span>
  </button>
);

export const StepPayment = ({ form, set, pagarmeEnabled }) => {
  const full = calcPricing({ ...form, option: "full" });
  const dep = calcPricing({ ...form, option: "deposit" });
  const days = daysUntil(form.eventDate);
  const depositBlocked = days !== null && days < 10;
  const parcelado = form.method === "pagarme";
  return (
    <div className="space-y-5" data-testid="checkout-step-4">
      {pagarmeEnabled && (
        <div className="grid md:grid-cols-2 gap-3" data-testid="payment-method-select">
          <Method id="payment-method-stripe" on={!parcelado} onClick={() => set("method", "stripe")} icon={QrCode}
            title="Pix ou cartão à vista" text="Pagamento integral com 5% de desconto." />
          <Method id="payment-method-pagarme" on={parcelado} onClick={() => set("method", "pagarme")} icon={CreditCard}
            title="Cartão parcelado em até 12x" text="Juros do parcelamento por conta do cliente. 1x sem juros." />
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        <Option id="checkout-payment-option-full" on={form.option === "full"} onClick={() => set("option", "full")} title="Pagamento integral" badge={parcelado ? null : "5% de desconto"}>
          <p>{parcelado ? "Valor" : "Pague agora"} <b className="text-[#FFD200] text-base">{brl(full.dueNow)}</b></p>
          {!parcelado && <p className="line-through text-zinc-500">{brl(full.subtotal)}</p>}
          <p>E pronto: evento 100% quitado.</p>
        </Option>
        <Option id="checkout-payment-option-deposit" on={form.option === "deposit"} disabled={depositBlocked} onClick={() => set("option", "deposit")} title="Reserva com sinal" badge="30% agora">
          <p>Sinal agora <b className="text-[#FFD200] text-base">{brl(dep.dueNow)}</b></p>
          <p>Restante {brl(dep.remaining)} até {dep.dueDate || "10 dias antes do evento"}</p>
          {depositBlocked && <p className="text-[#FF6B6B]">Indisponível para eventos em menos de 10 dias.</p>}
        </Option>
      </div>
      <p className="flex items-center gap-2 text-xs text-zinc-400"><Lock className="w-3.5 h-3.5" /> {parcelado
        ? "Pagamento seguro processado pela Pagar.me. O valor de cada parcela, com juros, aparece na tela de pagamento."
        : "Pagamento seguro processado pela Stripe (Pix ou cartão à vista)."} Evento em {fmtDate(form.eventDate)}.</p>
    </div>
  );
};
